import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';

export const flowListItemText: Components<Theme>['MuiListItemText'] = {
  defaultProps: {
    // has no effect
    inset: false,
    // set default typography
    // NOTE: we are using deprecated @mui props instead of slotProps to allow projects to still use them as well
    primaryTypographyProps: {
      variant: 'caption2',
    },
    secondaryTypographyProps: {
      variant: 'disclaimer1',
    },
    // slotProps: {
    //   primary: {
    //     variant: 'caption2',
    //   },
    //   secondary: {
    //     variant: 'disclaimer1',
    //   },
    // },
  },
  styleOverrides: {
    root: ({ theme }) => ({
      margin: '0',
      color: theme.palette.text.primary,
      // next ListItemTexts in the ListItem
      '& ~ .MuiListItemText-root': {
        // no need to grow
        flexGrow: '0',
        // make sure text is always visible and does not shrink
        flexShrink: '0',
        maxWidth: '100%',
        // align to right side
        textAlign: 'right',
      },
    }),
    primary: {
      // restrict 2 lines
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      WebkitLineClamp: '2',
      WebkitBoxOrient: 'vertical',
      // beware, due to important nested selector applying style
      // here disallows overwrites via sx
    },
    secondary: {
      // restrict 2 lines
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      WebkitLineClamp: '2',
      WebkitBoxOrient: 'vertical',
      // beware, due to important nested selector applying style
      // here disallows overwrites via sx
    },
    inset: {
      padding: '0',
    },
  },
};
